import React from 'react';
import '../styles.css';
import { useAuth } from '../context/AuthContext';
import { db } from '../firebase';
import { doc, onSnapshot, setDoc } from 'firebase/firestore';

const About = () => {
    const { isAdmin } = useAuth();
    const [content, setContent] = React.useState({
        p1: 'I am an associate professor of Ethics and Bioethics at Tulane University School of Medicine in New Orleans. I completed my PhD in Tübingen, Germany, conducted research in Melbourne, Australia, and taught in Guangzhou, China.',
        p2: 'Alongside my academic work, I am an abstract painter. My practice evolved from realism through film and philosophy to a focused exploration of abstraction.',
        p3: 'I work through color, texture, and material to expand perception—inviting viewers into a space where the finite and infinite converge.'
    });

    React.useEffect(() => {
        const unsub = onSnapshot(doc(db, 'siteContent', 'about'), (snap) => {
            const data = snap.data();
            if (data) setContent((c) => ({ ...c, ...data }));
        });
        return () => unsub();
    }, []);

    const save = async () => {
        await setDoc(doc(db, 'siteContent', 'about'), content, { merge: true });
    };

    return (
        <section id="about" className="section about-section">
            <div className="about-box">
                <div className="about-header">
                    <img
                        src="/portrait2.jpg"
                        alt="Portrait of Tzofit Ofengenden"
                        className="profile-photo"
                    />
                </div>
                <h2>About</h2>
                {!isAdmin && (
                    <>
                        <p>{content.p1}</p>
                        <p>{content.p2}</p>
                        <p>{content.p3}</p>
                    </>
                )}
                {isAdmin && (
                    <div style={{ display: 'grid', gap: 12 }}>
                        <textarea rows="4" value={content.p1} onChange={(e) => setContent({ ...content, p1: e.target.value })} />
                        <textarea rows="4" value={content.p2} onChange={(e) => setContent({ ...content, p2: e.target.value })} />
                        <textarea rows="4" value={content.p3} onChange={(e) => setContent({ ...content, p3: e.target.value })} />
                        <button type="button" className="btn-submit" onClick={save}>Save About Text</button>
                    </div>
                )}
            </div>
        </section>
    );
};

export default About;